module.exports = __webpack_public_path__ + "img/download_white.aa5ada1f.svg";